<template>
    <div class="access-control-container">
        <div class="page-header">
            <h2>人脸门禁管理</h2>
            <el-button type="primary" icon="el-icon-plus" @click="handleAddDevice">添加设备</el-button>
        </div>

        <!-- 搜索栏 -->
        <el-form :inline="true" :model="searchForm" class="search-form" @submit.native.prevent>
            <el-form-item>
                <el-input
                    v-model.trim="searchForm.deviceKeyword"
                    placeholder="设备编号/名称"
                    clearable
                    style="width: 200px"
                    @keyup.enter.native.prevent="handleSearch"
                ></el-input>
            </el-form-item>
            <el-form-item label="全部状态">
                <el-select v-model="searchForm.status" clearable style="width: 140px">
                    <el-option value="online" label="在线"></el-option>
                    <el-option value="offline" label="离线"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="全部位置">
                <el-select v-model="searchForm.location" clearable style="width: 140px">
                    <el-option v-for="item in locationOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 数据表格 -->
        <el-table
            :data="tableData"
            v-loading="tableLoading"
            :header-cell-style="{
                'text-align': 'center',
                'font-size': '16px',
                'font-weight': '600',
                color: '#2d2d2d',
                'background-color': '#f5f7fa'
            }"
            :cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
            :row-style="tableRowStyle"
        >
            <el-table-column prop="deviceNo" label="设备编号" min-width="100"></el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="120"></el-table-column>
            <el-table-column prop="location" label="安装位置" min-width="120"></el-table-column>
            <el-table-column prop="status" label="设备状态" width="100">
                <template slot-scope="scope">
                    <span :class="['status-dot', scope.row.status === 'online' ? 'online' : 'offline']"></span>
                    {{ scope.row.status === 'online' ? '在线' : '离线' }}
                </template>
            </el-table-column>
            <el-table-column prop="lastOnlineTime" label="最后在线时间" min-width="180"></el-table-column>
            <el-table-column prop="todayRecognitions" label="今日识别次数" width="120"></el-table-column>
            <el-table-column label="操作" width="240">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="info" size="mini" plain icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
                    <el-button type="danger" size="mini" plain icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="pagination"
        ></el-pagination>

        <!-- 新增/编辑弹窗（可复用） -->
        <el-dialog title="添加门禁设备" :visible.sync="addDialogVisible" :close-on-click-modal="false">
            <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="100px">
                <el-form-item label="设备编号" prop="deviceNo">
                    <el-input v-model.trim="addForm.deviceNo" placeholder="请输入设备编号"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input v-model.trim="addForm.deviceName" placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-form-item label="安装位置" prop="location">
                    <el-input v-model.trim="addForm.location" placeholder="请输入安装位置"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitAddForm" :loading="addLoading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { baseURL } from '@/utils/request.js';

export default {
    name: 'AccessControlDevice',
    data() {
        return {
            searchForm: {
                deviceKeyword: '',
                status: '',
                location: ''
            },
            tableData: [],
            tableLoading: false,
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            totalDataNumber: 0,
            locationOptions: [
                { value: '公司正大门', label: '公司正大门' },
                { value: '办公楼1楼大厅', label: '办公楼1楼大厅' },
                { value: '生产区入口', label: '生产区入口' }
            ],
            addDialogVisible: false,
            addLoading: false,
            addForm: {
                deviceNo: '',
                deviceName: '',
                location: ''
            },
            addRules: {
                deviceNo: [{ required: true, message: '设备编号不能为空', trigger: 'blur' }],
                deviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
                location: [{ required: true, message: '安装位置不能为空', trigger: 'blur' }]
            }
        };
    },
    methods: {
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'background-color: #ffffff';
            } else {
                return 'background-color: #fafafa';
            }
        },
        handleSearch() {
            this.pageNo = 1;
            this.queryDeviceList();
        },
        handleReset() {
            this.searchForm = {
                deviceKeyword: '',
                status: '',
                location: ''
            };
            this.pageNo = 1;
            this.queryDeviceList();
        },
        queryDeviceList() {
            const params = {
                pageNo: String(this.pageNo),
                pageSize: String(this.pageSize)
            };
            if (this.searchForm.deviceKeyword) params.deviceKeyword = this.searchForm.deviceKeyword;
            if (this.searchForm.status) params.status = this.searchForm.status;
            if (this.searchForm.location) params.location = this.searchForm.location;

            this.tableLoading = true;
            this.$postJson('dmc/AccessControl/queryDeviceList', params)
                .then((res) => {
                    if (res.code === 200) {
                        this.pageSize = res.result.pageSize;
                        this.currentPage = res.result.pageNum;
                        this.totalDataNumber = res.result.total * 1;
                        this.tableData = res.result.list || [];
                    } else {
                        this.tableData = [];
                        this.totalDataNumber = 0;
                    }
                    setTimeout(() => {
                        this.tableLoading = false;
                    }, 500);
                })
                .catch(() => {
                    this.tableLoading = false;
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryDeviceList();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.queryDeviceList();
        },
        handleAddDevice() {
            this.addForm = {
                deviceNo: '',
                deviceName: '',
                location: ''
            };
            this.addDialogVisible = true;
        },
        submitAddForm() {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.addLoading = true;
                    this.$postJson('dmc/AccessControl/addDevice', this.addForm)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('添加成功');
                                this.addDialogVisible = false;
                                this.queryDeviceList();
                            } else {
                                this.$message.error(res.message || '添加失败');
                            }
                            this.addLoading = false;
                        })
                        .catch(() => {
                            this.addLoading = false;
                        });
                }
            });
        },
        handleEdit(row) {
            this.$message.info(`编辑设备：${row.deviceName}`);
            // 可复用新增弹窗，或单独实现编辑弹窗
        },
        handleDetail(row) {
            this.$message.info(`查看设备详情：${row.deviceName}`);
            // 可跳转到详情页或打开详情弹窗
        },
        handleDelete(row) {
            this.$confirm('确定要删除该门禁设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$postJson('dmc/AccessControl/deleteDevice', { id: row.id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功');
                            this.queryDeviceList();
                        } else {
                            this.$message.error(res.message || '删除失败');
                        }
                    });
                })
                .catch(() => {
                    this.$message.info('已取消删除');
                });
        }
    },
    mounted() {
        this.queryDeviceList();
    }
};
</script>

<style lang="scss" scoped>
.access-control-container {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h2 {
            margin: 0;
            font-size: 24px;
            color: #333;
        }
    }

    .search-form {
        padding: 15px;
        background: #f9f9f9;
        border-radius: 4px;
        margin-bottom: 20px;
    }

    .status-dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 6px;

        &.online {
            background-color: #00b42a;
        }

        &.offline {
            background-color: #f53f3f;
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: center;
    }
}
</style>
